import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import "babel-polyfill";
import {
  default as Adal,
  AxiosAuthHttp,
  AuthenticationContext
} from "vue-adal";
import BootstrapVue from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Babel doesnt seem to handle this DOM polyfill
import "nodelist-foreach-polyfill";
import VueAutosuggest from "vue-autosuggest";

Vue.use(BootstrapVue);
Vue.use(VueAutosuggest);

Vue.use(Adal, {
  config: {
    tenant: process.env.VUE_APP_ADAL_TENANT,
    clientId: process.env.VUE_APP_ADAL_APPID,
    redirectUri: process.env.VUE_APP_REDIRECT_URL,
    cacheLocation: "localStorage"
  },
  // Set this to true for authentication on startup
  requireAuthOnInitialize: true,
  // Pass a vue-router object in to add route hooks with authentication and role checking
  router
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
